import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const travelPerk = defineConnector({
  identifier: "travelPerk",
  name: "Perk",
  tagLine: "Business travel booking and management",
  keywords: "perk travelperk business travel trips bookings invoices",
  logo,
  protocol: "http",
  tags: ["travel"],
  // TravelPerk became Perk and moved to api.perk.com, but the reference docs
  // still ship OpenAPI specs that name api.travelperk.com, so cover both.
  defaultUrlPattern: () => "https://api\\.(?:travel)?perk\\.com/.*",
  auth: (app) =>
    headerAuth([
      { name: "Authorization", value: app.secret.apiKey, scheme: "ApiKey" },
      { name: "Api-Version", value: "1" },
    ]),
  steps: [
    {
      title: "Create an API key in Perk",
      items: [
        {
          kind: "markdown",
          content:
            "As an admin, open **Settings › Developer tools › API tools** in Perk and create an API key. The value is shown once at creation, so copy it before closing the dialog. A key carries the same access as an account admin.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.perk.com/users?limit=1",
  },
});
